<ng-container *ngIf="transactionalDataState$ | async as state">
    <div class="moving-average-price-container mat-elevation-z8">
        <div class="table-header">

            <mat-form-field style="width: 20%" subscriptSizing="dynamic">
                <mat-label>{{ "app.external-data.daterange.label" | translate }}</mat-label>
                <mat-date-range-input [formGroup]="datefilterFormGroup" [rangePicker]="picker">
                    <input matStartDate formControlName="start">
                    <input matEndDate formControlName="end">
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
            </mat-form-field>
            <mat-form-field subscriptSizing="dynamic">
                <input matInput #filter (keyup)="applyFilter($event.target.value)" placeholder="Filter">
                <button mat-icon-button matSuffix aria-label="clear" *ngIf="filter.value"
                        (click)="filter.value=''; applyFilter('');">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
        </div>
        <mat-progress-bar color="accent" [style.visibility]="state.isLoading ? 'visible' : 'hidden'" mode="indeterminate"></mat-progress-bar>
        <div class="table-container">
            <table mat-table matSort [dataSource]="dataSource">

                <ng-container matColumnDef="articleNr">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "app.model.moving-average-price.articleNr.label" | translate}}</th>
                    <td mat-cell *matCellDef="let element"> {{element.articleNr}} </td>
                </ng-container>

                <ng-container matColumnDef="date">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "app.model.moving-average-price.date.label" | translate}}</th>
                    <td mat-cell *matCellDef="let element">
                        {{element.date | date: 'dd.MM.yyyy'}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="priceCents">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before">{{ "app.model.moving-average-price.price.label" | translate}}</th>
                    <td mat-cell *matCellDef="let element">
                        {{element.priceCents / 100 | currency:'EUR':'symbol':'1.2-2'}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="measureUnit">
                    <th mat-header-cell *matHeaderCellDef>{{ "app.model.moving-average-price.measureUnit.label" | translate}}</th>
                    <td mat-cell *matCellDef="let element" [matTooltip]="element.measureUnit.name">
                        <ng-container *ngIf="element.measureUnit.shortName != null; else displayFullName">
                            {{element.measureUnit.shortName}}
                        </ng-container>
                        <ng-template #displayFullName>
                            {{element.measureUnit.name}}
                        </ng-template>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="state.movingAveragePriceColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: state.movingAveragePriceColumns;"></tr>

            </table>
            <mat-paginator showFirstLastButtons [pageSizeOptions]="[20, 50]"></mat-paginator>
        </div>
    </div>
</ng-container>
